import react from "react";
import { Helmet } from "react-helmet";
import News from "../../components/news/News";

const Homepage = () => {
  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Latest News, Gold & Silver Prices, and Market Updates</title>
        <meta
          name="description"
          content="Get the latest international news, GST updates, and live gold & silver prices. Stay informed on stock market trends in India and globally."
        />
        <meta
          name="keywords"
          content="news, gold price, silver price, stock market, GST, India news, international news, finance, business,today gold rate, current gold price, live gold rate, latest gold rate, 22k gold rate, 24k gold rate, gold price in India, silver price today"
        />

        {/* Social Media (Open Graph) */}
        <meta property="og:title" content="Latest News & Gold Prices | Gold rate today" />
        <meta
          property="og:description"
          content="Stay updated with real-time gold and silver prices, GST changes, and stock market trends."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://gold-rate-today.com//" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Latest News & Gold Prices | Gold Rate Today" />
        <meta
          name="twitter:description"
          content="Check live gold, silver, and stock market updates with global and local news."
        />
      </Helmet>

      {/* international-news start */}
      <News heading="International News" api="https://gnews.io/api/v4/search?q=tariff&lang=en&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />

      {/* international-news end */}

      {/* gold news start */}
      <News heading="Gold trend" api="https://gnews.io/api/v4/search?q=gold&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
      {/* gold news end */}

      {/* gst news start */}
      <News heading="GST 2.0 Slab" api="https://gnews.io/api/v4/search?q=gst&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
      {/* gst news end */}

      {/* stocks news start */}
      <News heading="stocks" api="https://gnews.io/api/v4/search?q=stock%20market&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
      {/* stocks news end */}
    </>
  )
}

export default Homepage;